// MessageReplyInput.js
import { connect } from 'react-redux';

import MessageInput from '../component/MessageInput.jsx';

import getIsPermissionMatched from '../selector/getIsPermissionMatched.js';
import getOperationData from '../selector/getOperationData.js';

import {
  MASQUED_PHRASES_FOR_CHAT,
  JWT_SCOPE_CREATOR,
  JWT_SCOPE_UPLOADER_REPLY,
} from '../RemoteConfigKeys.js';
import { getIsOnAndroid } from '../resource/getUserAgent.js';

import setMessageReplyInputValue from '../action/setMessageReplyInputValue.js';
import setMessageInputHeight from '../action/setMessageInputHeight.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import replyMessage from '../action/replyMessage.js';
import setInputFocused from '../action/setInputFocused.js';
import setGiftPanel from '../action/setGiftPanel.js';
import pushToastr from '../action/pushToastr.js';

function mapStateToProps(state, { messageId }) {
  return {
    hasGift: true,
    type: 'message',
    hasCamera: true,
    isVisibleMenuBtnWhenInputEmpty: true,
    isFocused: getOperationData(
      state,
      ['message', messageId],
      'isInputFocused'
    ),
    text: getOperationData(state, ['message', messageId], 'replyInputText'),
    media: getOperationData(state, ['message', messageId], 'replyMedia'),
    isGiftPanelOpen: getOperationData(
      state,
      ['gift', 'panel'],
      'isGiftPanelOpen'
    ),
    isOnAndroid: getIsOnAndroid(),
    isCP: getIsPermissionMatched(state, JWT_SCOPE_CREATOR),
    canCreateMessage: getIsPermissionMatched(state, JWT_SCOPE_UPLOADER_REPLY),
    forbiddenWords: getRemoteConfigData(state, MASQUED_PHRASES_FOR_CHAT),
  };
}

function mapDispatchToProps(dispatch, { messageId }) {
  return {
    onChange: ({ text, media }) =>
      dispatch(setMessageReplyInputValue({ messageId, text, media })),
    setGiftPanel: isOpen => dispatch(setGiftPanel({ isOpen })),
    setMessageInputHeight: ({ height, messageId }) =>
      dispatch(setMessageInputHeight({ height, messageId })),
    onSubmit: ({ text, media }) =>
      dispatch(replyMessage({ messageId, text, media })),
    setInputFocused: isFocused => {
      dispatch(
        setInputFocused({ id: messageId, isFocused, inputType: 'replyMessage' })
      );
    },
    pushToastr: ({ textKey, textKeyOption = {} }) =>
      dispatch(
        pushToastr({
          textKey,
          textKeyOption,
          durationSec: 5,
          color: 'error',
        })
      ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(MessageInput);
